import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import Footer from "../../components/default/Footer";
import Header from "../../components/default/Header";
import PageNotFound from "../../components/default/PageNotFound";
import {
  getCurrentQuizzes,
  getQuizBySession,
  getQuizReview,
  getSubject,
  resetAll,
  startQuiz,
  submitQuiz,
  deleteQuizReview,
} from "../../features/my-study/myStudySlice";
import useEffectOnce from "../../helpers/useEffectOnce";

const QuizStart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isQuizSubmit, setIsQuizSumbit] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const { sessionId, subjectId } = useParams();
  const [currentQuiz, setCurrentQuiz] = useState({});
  const [currentQuizzes, setCurrentQuizzes] = useState([]);
  const [currentQuizReview, setCurrentQuizReview] = useState({});
  const [currentSubject, setCurrentSubject] = useState({});
  const [currentQuizIndex, setCurrentQuizIndex] = useState(-1);

  const { isLoading, data, message } = useSelector((state) => state.myStudy);

  const fetchAll = async () => {
    await Promise.all([
      dispatch(getSubject(subjectId)),
      dispatch(getQuizBySession(sessionId)),
      dispatch(getCurrentQuizzes()),
    ]);

    setIsLoaded(true);
  };

  useEffectOnce(() => {
    dispatch(resetAll());
    fetchAll();
  });

  const doShowQuizResult = (e, quizId) => {
    e.preventDefault();

    dispatch(getQuizReview(quizId));
  };

  const takeQuiz = (quizId) => {
    dispatch(startQuiz(quizId));
  };

  const doSubmitQuiz = () => {
    dispatch(
      submitQuiz({
        answers: [],
        quizId: currentQuiz.quiz.id,
        materialId: currentQuizzes[currentQuizIndex].material_enrolled_id,
      })
    );

    setIsQuizSumbit(true);
  };

  useEffect(() => {
    if (Object.values(currentQuizReview).length !== 0) {
      let tableHeader = `<thead>
        <tr>
          <th>No</th>
          <th>Jawaban Anda</th>
          <th>Informasi</th>
        </tr>
      </head>`;
      let tableBody = "";

      currentQuizReview.forEach((quiz, index) => {
        tableBody += `<tr>
          <td>${index + 1}.</td>
          <td>${quiz.user_answer}</td>
          <td>${
            quiz.is_correct
              ? '<i class="fas fa-check text-success"></i>'
              : '<i class="fas fa-times text-danger"></i>'
          }
        </tr>`;
      });

      Swal.fire({
        icon: "info",
        title: "Quiz Review",
        html:
          "<table class='table table-striped'>" +
          tableHeader +
          "<tbody>" +
          tableBody +
          "</tbody>" +
          "</table>",
        confirmButtonText: "Oke",
      });
      setCurrentQuizReview([]);
      dispatch(deleteQuizReview());
    }

    if (message === "SUCCESS_TAKE_QUIZ")
      navigate(`${data?.quiz_detail?.material_enrolled_id}`);

    if (data?.quiz_review) {
      setCurrentQuizReview(data.quiz_review);
    }
    if (data?.quizzes) setCurrentQuizzes(data.quizzes);
    if (data?.subject) setCurrentSubject(data.subject);
    if (data?.quiz) setCurrentQuiz(data.quiz);
    if (
      Object.keys(currentQuizzes).length !== 0 &&
      Object.keys(currentQuiz).length !== 0
    ) {
      let currentindex = currentQuizzes.findIndex(
        (quiz) => quiz.id === currentQuiz.id
      );
      setCurrentQuizIndex(currentindex);

      if (!isQuizSubmit && currentQuizIndex >= 0) {
        if (
          new Date(currentQuizzes[currentQuizIndex].deadline).getTime() <
          new Date().getTime()
        )
          doSubmitQuiz();
      }
    }
  }, [
    dispatch,
    data,
    currentQuizzes,
    currentQuiz,
    currentQuizIndex,
    message,
    currentQuizReview,
  ]);

  if (message === "no quiz found") return <PageNotFound />;

  return (
    <>
      <Header />
      <main>
        {(isLoading && !isLoaded) ||
        Object.keys(currentSubject).length === 0 ||
        Object.keys(currentQuiz).length === 0 ? (
          <>
            <section className="bg-light py-0 py-sm-5">
              <div
                className="container text-center"
                style={{ marginTop: "165px", marginBottom: "165px" }}
              >
                <div className="row">
                  <div className="col-12">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          <>
            <section
              className="bg-blue align-items-center d-flex"
              style={{
                background:
                  "url('/assets/images/pattern/04.png') no-repeat center center",
                backgroundSize: "cover",
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12 text-center">
                    <h1 className="text-white">{currentSubject.name}</h1>
                    <div className="d-flex justify-content-center">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-dots mb-0">
                          <li className="breadcrumb-item">
                            <Link to="/kategori">Kategori</Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to="/studi-ku">Pelatihan-Ku</Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to={`/studi-ku/${subjectId}`}>
                              {currentSubject.name}
                            </Link>
                          </li>
                          <li
                            className="breadcrumb-item active"
                            aria-current="page"
                          >
                            Quiz
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="pb-0 pt-lg-5">
              <div className="container">
                <div className="row">
                  <div className="card shadow">
                    <div className="card-body py-4">
                      {currentQuizIndex !== -1 &&
                      currentQuizzes.length !== 0 ? (
                        <>
                          <div className="col-md-12 mb-4">
                            <div className="alert alert-info mb-4">
                              {/* anda telah memulai Quiz ini {(new Date(currentQuizzes[currentQuizIndex].deadline).getTime() - new Date().getTime()).toLocaleString("en-US")} */}
                              Anda telah memulai Quiz ini. Anda harus
                              menyelesaikan pada{" "}
                              <b>
                                {
                                  new Date(
                                    currentQuizzes[currentQuizIndex].deadline
                                  )
                                    .toISOString()
                                    .split("T")[0]
                                }
                                ,{" "}
                                {
                                  new Date(
                                    currentQuizzes[currentQuizIndex].deadline
                                  )
                                    .toString()
                                    .split(" ")[4]
                                }
                              </b>
                            </div>
                            <div className="d-sm-flex justify-content-sm-between mb-2 mb-sm-3">
                              <div>
                                <h5 className="card-title mb-0">
                                  <Link
                                    to={`/studi-ku/${subjectId}/pertemuan/${sessionId}/modul/${module.id}`}
                                  >
                                    {currentQuiz.quiz.description}
                                  </Link>
                                </h5>
                              </div>
                            </div>
                            <div className="d-sm-flex align-items-center">
                              <Link
                                className="btn btn-dark"
                                to={`${currentQuizzes[currentQuizIndex]?.material_enrolled_id}`}
                              >
                                <i className="fas fa-play me-3"></i>
                                Lanjutkan Quiz
                              </Link>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-lg-12 col-xl-12">
                            {currentQuiz.summary.length !== 3 ? (
                              <>
                                <div className="alert alert-info mb-4">
                                  Anda dapat memulai Quiz ini dengan klik tombol
                                  `Mulai Quiz` di bawah ini.
                                </div>
                                <div className="d-sm-flex justify-content-sm-between mb-2 mb-sm-3">
                                  <div>
                                    <h5 className="card-title mb-0">
                                      {currentQuiz.quiz.description}
                                    </h5>
                                  </div>
                                </div>
                                <div className="d-sm-flex align-items-center">
                                  {isLoading && isLoaded ? (
                                    <>
                                      <button
                                        className="btn btn-dark"
                                        style={{ cursor: "not-allowed" }}
                                      >
                                        <span className="spinner-border spinner-border-sm"></span>
                                        &nbsp; &nbsp;Memulai Quiz ...
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="btn btn-dark"
                                        onClick={() =>
                                          takeQuiz(currentQuiz.quiz.id)
                                        }
                                      >
                                        <i className="fas fa-play me-3"></i>
                                        Mulai Quiz
                                      </button>
                                    </>
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="alert alert-info mb-0">
                                  anda sudah mengambil Quiz sebanyak 3 kali dan
                                  anda sudah tidak dapat mengambil Quiz ini
                                  lagi.
                                </div>
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="pb-0 py-lg-5">
              <div className="container">
                <div className="row">
                  <div className="card shadow">
                    <div className="card-body py-4">
                      <div className="col-md-12 mb-4">
                        <h5>Riwayat Quiz anda</h5>
                        <div className="row">
                          {currentQuiz.summary.length !== 0 ? (
                            <>
                              {currentQuiz.summary.map((quizTaken, number) => (
                                <>
                                  <div className="col-md-12 col-lg-6 mt-4">
                                    <div className="card shadow border p-2">
                                      <div className="card-body">
                                        <h4
                                          style={{ cursor: "pointer" }}
                                          className="card-title d-block text-start"
                                          onClick={(e) =>
                                            doShowQuizResult(e, quizTaken.id)
                                          }
                                        >
                                          <strong>
                                            Quiz Pengambilan Ke-{number + 1}
                                          </strong>
                                        </h4>
                                        <span className="text-dark pb-2">
                                          <i className="fa fa-info-circle fa-fw me-2"></i>
                                          Klik quiz untuk melihat quiz review.
                                        </span>
                                        <hr />
                                        <ul className="list-group">
                                          <li className="list-group-item d-flex justify-content-between align-items-center border-0 ps-0">
                                            Pengumpulan anda :{" "}
                                            <span className="badge bg-dark rounded-pill">
                                              {
                                                quizTaken.activity_detail
                                                  .date_submit
                                              }
                                            </span>
                                          </li>
                                          <li className="list-group-item d-flex justify-content-between align-items-center border-0 ps-0">
                                            Jumlah Soal :
                                            <span className="badge bg-info rounded-pill">
                                              {
                                                quizTaken.activity_detail
                                                  .number_of_questions
                                              }
                                            </span>
                                          </li>
                                          <li className="list-group-item d-flex justify-content-between align-items-center border-0 ps-0">
                                            Jawaban Benar :
                                            <span className="badge bg-success rounded-pill">
                                              {
                                                quizTaken.activity_detail
                                                  .correct_answers
                                              }
                                            </span>
                                          </li>
                                          <li className="list-group-item d-flex justify-content-between align-items-center border-0 ps-0">
                                            Jawaban Salah :
                                            <span className="badge bg-danger rounded-pill">
                                              {quizTaken.activity_detail
                                                .number_of_questions -
                                                quizTaken.activity_detail
                                                  .correct_answers}
                                            </span>
                                          </li>
                                        </ul>

                                        <div className="h4 mt-2">Nilai :</div>
                                        <div className="h2">
                                          {quizTaken.score}
                                        </div>
                                        {quizTaken.status === "FAILED" ? (
                                          <>
                                            <span className="badge bg-danger">
                                              {quizTaken.status}
                                            </span>
                                          </>
                                        ) : quizTaken.status === "PASSED" ? (
                                          <>
                                            <span className="badge bg-info">
                                              {quizTaken.status}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="badge bg-sucess">
                                              {quizTaken.status}
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))}
                            </>
                          ) : (
                            <>
                              <div className="col-md-12">
                                {currentQuizIndex !== -1 &&
                                currentQuizzes.length !== 0 ? (
                                  <>
                                    <div className="alert alert-danger mb-0 mt-1">
                                      anda sedang memulai Quiz. anda tidak dapat
                                      melihat riwayat Quiz anda!
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="alert alert-info mb-0 mt-1">
                                      Belum ada Quiz yang telah anda selesaikan
                                      saat ini.
                                    </div>
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </main>
      <Footer />
    </>
  );
};

export default QuizStart;
